import { CommonModule } from '@angular/common';
import { Component, Inject } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatCheckboxModule } from '@angular/material/checkbox';
import {
  MAT_DIALOG_DATA,
  MatDialogModule,
  MatDialogRef,
} from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MasterPermission } from '../../../interfaces/master-permission';
import { SuperadminService } from '../../../services/superadmin.service';
import { MatChipsModule } from '@angular/material/chips';

// add-global-permission-dialog.component.ts
@Component({
  selector: 'app-add-global-permission-dialog',
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    MatButtonModule,
    MatInputModule,
    MatFormFieldModule,
    MatIconModule,
    MatCheckboxModule,
    MatDialogModule,
    MatChipsModule
  ],
  templateUrl: './add-global-permission-dialog.component.html'
})
export class AddGlobalPermissionDialogComponent {
  globalUserSearch = '';
  searchResults: any[] = [];
  selectedUserId: number | null = null;
  selectedPermIds: Set<number> = new Set();

  constructor(
    @Inject(MAT_DIALOG_DATA)
    public data: { globalPermissions: MasterPermission[] },
    private dialogRef: MatDialogRef<AddGlobalPermissionDialogComponent>,
    private superadminService: SuperadminService,
  ) {}

  searchUsers(): void {
    const q = this.globalUserSearch.trim().toLowerCase();
    if (!q) {
      this.searchResults = [];
      return;
    }

    this.superadminService.getAllUsers().subscribe({
      next: (res) => {
        this.searchResults = (res.data ?? []).filter(
          (u: any) =>
            u.usr_name.toLowerCase().includes(q) ||
            u.usr_mail.toLowerCase().includes(q),
        );
      },
    });
  }

  confirm(): void {
    this.dialogRef.close({
      userId: this.selectedUserId,
      permIds: Array.from(this.selectedPermIds),
    });
  }
}
